import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import clsx from "clsx";
import { MTableActions } from "material-table";
import { remCalc } from "../../../utils/helpers";

/** Custom component for actions to disable/enable them when needed
 * @param {Object} props
 * @param {ref} props.nameInputRef ref for input for name field
 */

const useStyles = makeStyles(theme => ({
  btnSave: {
    textTransform: "none",
    boxShadow: "none !important",
    height: remCalc(30),
    minWidth: remCalc(51),
    padding: theme.spacing(0.875, 1.25),

    "&.Mui-disabled, &.Mui-disabled:hover": {
      backgroundColor: "#1329FE",
      color: "#fff",
      opacity: "38%"
    }
  },
  btnCancel: {
    color: "#808080",
    height: remCalc(30),
    minWidth: remCalc(63),
    marginRight: theme.spacing(1),
    padding: theme.spacing(0.875, 1.25)
  }
}));

function CustomActions({
  isEditingDuplicate,
  unitDialog,
  isValidQuantity,
  ...props
}) {
  const classes = useStyles();
  const isEditActions =
    props &&
    props.actions[0]?.tooltip === "Save" &&
    (!props.data ||
      (props.data.tableData.editing &&
        props.data.tableData.editing !== "delete"));
  const [disabled, setDisabled] = useState(isEditActions);
  const [isDeleting, setIsDeleting] = useState(false);

  // check quantity field for unit dialog
  useEffect(() => {
    if (isEditActions && unitDialog) {
      setDisabled(!isValidQuantity);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValidQuantity]);

  useEffect(() => {
    const row = document.querySelector(".MuiTableRow-root[mode=delete]");
    if (row) setIsDeleting(true);
  }, []);

  if (props?.actions[0]?.tooltip === "Save") {
    return (
      <>
        <Button
          onClick={props.actions[1].onClick}
          className={classes.btnCancel}
          disabled={isEditingDuplicate}
          id="cancel-action"
          data-cy="projects-cancel"
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          className={clsx(classes.btnSave)}
          id="save-action"
          style={{ backgroundColor: `${isDeleting ? "#D93024" : ""}` }}
          onClick={() => {
            props.actions[0].onClick();
          }}
          disabled={disabled}
        >
          {!isDeleting ? "Save" : "Delete"}
        </Button>
      </>
    );
  } else {
    return <MTableActions {...props} />;
  }
}

export default CustomActions;
